import { render, staticRenderFns } from "./liveEvents.vue?vue&type=template&id=344a2a58&scoped=true&"
import script from "./liveEvents.vue?vue&type=script&lang=js&"
export * from "./liveEvents.vue?vue&type=script&lang=js&"
import style0 from "./liveEvents.vue?vue&type=style&index=0&id=344a2a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a2a58",
  null
  
)

export default component.exports